import { IDefault } from "../default.type";

export class DefaultAvailabilityStatic {
  static default: IDefault = { id: "14174dbf-e805-4532-9b1c-35d7b3cead8f", name: "Padrão" };
  static interns: IDefault = { id: "0f23dacc-8595-4516-8c16-50c15417448b", name: "Estagiário" };
}